import { Component } from '@angular/core';
import { Breadcrumb } from '../shared/breadcrumb/breadcrumb';

@Component({
  selector: 'app-pricing',
  imports: [Breadcrumb],
  templateUrl: './pricing.component.html',
  styleUrl: './pricing.component.css',
   standalone: true,
})
export class PricingComponent {

}
